<div class="domain-container">
    <div class="top-bar">
        <div class="left-section">
            <h2 class="title">Domain & Enrollment</h2>
            <p class="subtitle">Manage domain settings and auto-enrollment</p>
        </div>

        <div class="right-section">
            <button mat-icon-button aria-label="Notifications">
                <mat-icon matBadge="2" matBadgeColor="warn">notifications</mat-icon>
            </button>

            <div class="user-info">
                <div>
                    <div class="name">Admin User</div>
                    <div class="email">{{ adminEmail }}</div>
                </div>
                <div class="avatar">AD</div>
            </div>
        </div>
    </div>

    <div class="domain-container-content">
        <mat-card class="card">
            <h3 class="section-title">Allowed Domains</h3>
            <p class="section-desc">Configure email domains that can access your institution</p>

            <div class="domain-list">
                <div class="domain-item primary">
                    <span>{{ primaryDomain }}</span>
                    <span class="tag">Primary</span>
                </div>

                <div class="domain-item" *ngFor="let domain of allowedDomains; let i = index">
                    <span>{{ domain }}</span>
                    <button mat-icon-button color="warn" (click)="removeDomain(i)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </div>

            <div class="domain-add">
                <mat-form-field appearance="outline" class="domain-input">
                    <mat-label>Add new domain (e.g., alumni.sit.ac.in)</mat-label>
                    <input matInput [(ngModel)]="newDomain" />
                </mat-form-field>
                <button mat-flat-button color="primary" (click)="addDomain()">Add</button>
            </div>

            <div class="info-box">
                Only users with institutional domain emails ({{ primaryDomain }}) can join
                {{ institutionName }}.
            </div>
        </mat-card>
        <mat-card class="card">
            <h3 class="section-title">Enrollment Settings</h3>
            <p class="section-desc">
                Configure how users are enrolled in your institution
            </p>

            <div class="toggle-item">
                <div>
                    <strong>Auto Enrollment</strong>
                    <p>Automatically enroll users with verified institutional email</p>
                </div>
                <mat-slide-toggle [(ngModel)]="autoEnrollment"></mat-slide-toggle>
            </div>

            <div class="toggle-item">
                <div>
                    <strong>Email Verification Required</strong>
                    <p>Require email verification before granting access</p>
                </div>
                <mat-slide-toggle [(ngModel)]="emailVerificationRequired"></mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select default batch for new students</mat-label>
                <mat-select [(ngModel)]="defaultBatch">
                    <mat-option *ngFor="let batch of batches" [value]="batch">{{ batch }}</mat-option>
                </mat-select>
            </mat-form-field>

            <p class="note">
                New students will be automatically assigned to this batch
            </p>

            <div class="btn-container">
                <button mat-flat-button color="primary" (click)="saveSettings()" class="save-btn">Save Settings</button>
            </div>
        </mat-card>
    </div>
</div>